import { z } from 'zod'

export const locales = ['en', 'da', 'es', 'fr', 'nn', 'se'] as const

export const localesNames = {
  en: 'English',
  da: 'Dansk',
  es: 'Español',
  fr: 'Français',
  nn: 'Norsk',
  se: 'Svenska',
}

export const translationKeys = [
  'string.Add-date',
  'string.Confirmed',
  'string.Location',
  'string.Order-Number',
  'string.Questionnaire-Placeholder',
  'string.Questionnaire-Type-Answer',
  'string.Optional',
  'string.Skip',
  'string.Select-an-option',
  'string.Price',
  'string.Expand-Order',
  'string.Ticket-Delivery',
  'string.Ticket-Delivery-Football',
  'string.Ticket-Delivery-eTicket',
  'string.Ticket-Type',
  'string.Ticket-Type-Attraction',
  'string.Ticket-Type-Football',
  'string.Ticket-Type-Show',
  'string.Ticket-Type-Transport',
  'string.Add-return-date',
  'string.Add-time',
  'string.Add',
  'string.Continue-Shopping',
  'string.Availabilities',
  'string.No-Availabilities',
  'string.Adding-to-cart',
  'string.Address-line-1',
  'string.Address-line-2',
  'string.Address',
  'string.County',
  'string.Back-To-Home',
  'string.Success-Guest-Already-Submitted',
  'string.Adults',
  'string.All-rights-reserved',
  'string.Back',
  'string.About',
  'string.Book-tickets',
  'string.Cancel',
  'string.Change-language',
  'string.Children',
  'string.Currency',
  'string.Language',
  'string.City',
  'string.Choose-your-preferred-store-currency',
  'string.Close',
  'string.Confirm-new-password',
  'string.Confirm-password',
  'string.Cost-breakdown',
  'string.Country',
  'string.Current-password',
  'string.Date',
  'string.Discount',
  'string.Edit',
  'string.Email-address',
  'string.Event-tickets',
  'string.Expired',
  'string.Expired-Description',
  'string.Favourites',
  'string.First-name',
  'string.Forgot-password',
  'string.From',
  'string.Gift-card',
  'string.Home',
  'string.Last-name',
  'string.Match',
  'string.Nationality',
  'string.Login',
  'string.Logout',
  'string.More-info',
  'string.Name',
  'string.New-password',
  'string.One-way',
  'string.Open-return',
  'string.or',
  'page.guest-data.title',
  'string.guest-data.title',
  'string.guest-data.description',
  'string.guest-data.not-required',
  'string.Next-Button',
  'string.Go-To-My-Account',
  'string.Guest',
  'string.Birthdate',
  'string.Thanks',
  'string.Guest-Form-Disclaimer-1',
  'string.Guest-Form-Disclaimer-2',
  'string.Document',
  'string.Back-To-Category',
  'string.View-All-Tickets',
  'string.View-All-Fixtures',
  'string.Previous-Button',
  'string.Message',
  'string.Submit-Guest',
  'string.Success-Guest-Title',
  'string.Success-Guest-Description',
  'string.Page-not-found',
  'string.Pages',
  'string.Page',
  'string.Password',
  'string.Personal-details',
  'string.Phone-number',
  'string.Postal-code',
  'string.Products',
  'string.Register',
  'string.Remove',
  'string.Return',
  'string.Save',
  'string.Search',
  'string.Seating-Map',
  'string.Select',
  'string.Share-this-page',
  'string.Show-all',
  'string.Show-less',
  'string.Show-more',
  'string.Submit',
  'string.Subtotal',
  'string.Summary',
  'string.Tickets-from',
  'string.tickets',
  'string.ticket',
  'string.Tickets',
  'string.Tickets-Left',
  'string.Final-Ticket',
  'string.All-Dates',
  'string.All-Locations',
  'string.See-Tickets',
  'string.Today',
  'string.Tomorrow',
  'string.Time',
  'string.Ticket-Details',
  'string.Ticket-category',
  'string.Secure-Payments',
  'string.Tickets-Price',
  'string.Buy',
  'string.To',
  'string.Total',
  'string.years',
  'string.Your-account',
  'string.Your-password',
  'string.Pickup-point',

  'component.newsletter.title',
  'component.newsletter.description',
  'component.newsletter.label.name',
  'component.newsletter.label.email',
  'component.newsletter.button',

  'component.search-button.label',

  'component.socials.title',
  'component.socials.description',

  'component.countdown-timer.description',
  'component.countdown-timer.expired.description',

  'component.coupon.add',
  'component.coupon.remove',
  'component.coupon.label',
  'component.coupon.button',

  'component.tickets.show.quantity.label',
  'component.tickets.show.button',

  'component.tickets.attraction.category.label',
  'component.tickets.attraction.category.placeholder',
  'component.tickets.attraction.participants.label',
  'component.tickets.attraction.participants.description',
  'component.tickets.attraction.button',

  'component.tickets.transport.type.label',
  'component.tickets.transport.date.label',
  'component.tickets.transport.participants.label',
  'component.tickets.transport.participants.description',
  'component.tickets.transport.fare.label',
  'component.tickets.transport.button.get-availability',
  'component.tickets.transport.button.submit',

  'modal.add-to-cart.button',

  'modal.forgot-password.title',
  'modal.forgot-password.description',
  'modal.forgot-password.login.text',

  'modal.login.title',
  'modal.login.register.text',
  'modal.login.continue-button',

  'modal.register.title',
  'modal.register.login.text',

  'page.category.products.title',
  'page.category.related.title',
  'page.category.no-products.title',
  'page.category.no-products.description',

  'page.product.body.title',
  'page.product.notes.title',
  'page.product.notes.title.football',
  'page.product.additionalNotes.title',
  'page.product.additionalNotes.title.football',
  'page.product.additionalDescription.title',
  'page.product.unavailable.description',
  'page.product.choose-hotel',

  'package.step.ticket',
  'package.step.hotel',
  'package.step.checkout',
  'package.back-to-tickets',
  'package.hotels.title',
  'package.hotels.complete-price',
  'package.hotels.per-person-short',
  'package.hotels.price-explainer',
  'package.hotels.total-suffix',
  'package.your-package',
  'package.tickets',
  'package.hotel',
  'package.ticket-count',
  'package.hotel-nights',
  'package.total',
  'package.travellers-note',
  'package.continue-to-checkout',
  'package.sold-together-note',
  'package.breakdown-title',
  'package.sold-together-short',
  'package.price-after-hotel',
  'package.cancel-and-return',
  'package.hotels.about',
  'package.change-hotel',
  'package.sort-by',
  'package.sort.closest',
  'package.sort.price_asc',
  'package.sort.rating',
  'package.hotels.select',
  'package.hotels.in-package',
  'package.hotels.badge-closest',
  'package.hotels.badge-premium',
  'package.hotels.shown-count',
  'package.hotels.show-more',
  'package.hotels.searching',
  'package.hotels.no-results',
  'package.hotels.search-failed',
  'package.search.dates',
  'package.search.travellers',
  'package.search.area',
  'package.search.area-near-venue',
  'package.search.submit',
  'package.search.check-in',
  'package.search.check-out',
  'package.search.adults-count',
  'package.search.children-count',
  'package.search.rooms-count',

  'page.gift-card.purchase.amount.title',
  'page.gift-card.purchase.amount.description',
  'page.gift-card.currency.purchase',
  'page.gift-card.currency.redemption',
  'page.gift-card.currency.cart-locked',
  'page.gift-card.purchase.amount.custom-placeholder',
  'page.gift-card.purchase.amount.range',
  'page.gift-card.purchase.recipient.title',
  'page.gift-card.purchase.recipient.description',
  'page.gift-card.purchase.recipient.name',
  'page.gift-card.purchase.recipient.email',
  'page.gift-card.purchase.recipient.email-help',
  'page.gift-card.purchase.summary',
  'page.gift-card.purchase.button',
  'page.gift-card.purchase.lookup.title',
  'page.gift-card.purchase.lookup.description',
  'page.gift-card.purchase.lookup.button',
  'page.gift-card.purchase.config-warning',
  'page.gift-card.purchase.error.amount',
  'page.gift-card.purchase.error.min',
  'page.gift-card.purchase.error.max',
  'page.gift-card.purchase.error.recipient-name',
  'page.gift-card.purchase.error.recipient-email',
  'page.gift-card.lookup.title',
  'page.gift-card.lookup.description',
  'page.gift-card.lookup.placeholder',
  'page.gift-card.lookup.button',
  'page.gift-card.lookup.error.required',
  'page.gift-card.lookup.error.not-found',
  'page.gift-card.lookup.result.code',
  'page.gift-card.lookup.result.status',
  'page.gift-card.lookup.result.expiry',
  'page.gift-card.lookup.result.original',
  'page.gift-card.lookup.result.remaining',
  'page.gift-card.lookup.history.title',
  'page.gift-card.lookup.history.activity',
  'page.gift-card.lookup.history.order',
  'page.gift-card.lookup.history.balance',
  'page.gift-card.lookup.history.empty',
  'page.gift-card.cart.recipient',
  'page.gift-card.cart.email',
  'page.gift-card.cart.value',
  'page.gift-card.cart.no-message',

  'page.faqs.title',
  'page.faqs.description',
  'page.faqs.extra.description',
  'page.faqs.extra.contact.title',
  'page.faqs.extra.contact.contact_chat',
  'page.faqs.extra.contact.open_chat',
  'page.faqs.extra.contact.copy_email',
  'page.faqs.extra.contact.call_us',

  'page.rate-us.not_reviewed',
  'page.rate-us.thanks',
  'page.rate-us.we_glad',
  'page.rate-us.bad_review_thanks',
  'page.rate-us.good_review',
  'page.rate-us.submit_review',
  'page.rate-us.hope_you_like',
  'page.rate-us.submit_review_trustpilot',

  'page.cart.title',
  'page.cart.empty.description',
  'page.cart.list.guarantees',
  'page.cart.payment.button',
  'page.cart.upsell.title',
  'page.cart.upsell.description',
  'page.cart.upsell.product-title',
  'page.cart.hotels.section-title',
  'page.cart.hotels.mandatory-notice',
  'page.cart.hotels.pill',
  'page.cart.hotels.title',
  'page.cart.hotels.description',
  'page.cart.hotels.find-button',
  'page.cart.hotels.close',
  'page.cart.hotels.date',
  'page.cart.hotels.date-range',
  'page.cart.hotels.checkout',
  'page.cart.hotels.who-is-going',
  'page.cart.hotels.room',
  'page.cart.hotels.adults',
  'page.cart.hotels.children',
  'page.cart.hotels.child-age',
  'page.cart.hotels.add-room',
  'page.cart.hotels.confirm',
  'page.cart.hotels.confirm-dates',
  'page.cart.hotels.search-button',
  'page.cart.hotels.cancel',
  'page.cart.hotels.back-to-order',
  'page.cart.hotels.results-title',
  'page.cart.hotels.sort',
  'page.cart.hotels.closest',
  'page.cart.hotels.lowest-price',
  'page.cart.hotels.highest-price',
  'page.cart.hotels.highest-rated',
  'page.cart.hotels.filter',
  'page.cart.hotels.breakfast',
  'page.cart.hotels.wifi',
  'page.cart.hotels.cancellation',
  'page.cart.hotels.free-cancellation',
  'page.cart.hotels.available',
  'page.cart.hotels.results-count',
  'page.cart.hotels.venue',
  'page.cart.hotels.miles-from-venue',
  'page.cart.hotels.total-stay',
  'page.cart.hotels.city',
  'page.cart.hotels.choose-city',
  'page.cart.hotels.city-unknown',
  'page.cart.hotels.map-unavailable',
  'page.cart.hotels.show-more',
  'page.cart.hotels.show-less',
  'page.cart.hotels.nights-count',
  'page.cart.hotels.min-stay',
  'page.cart.hotels.max-stay',
  'page.cart.hotels.per-night',
  'page.cart.hotels.more-info',
  'page.cart.hotels.add-to-order',
  'page.cart.hotels.no-results',
  'page.cart.hotels.details-title',
  'page.cart.hotels.excellent',
  'page.cart.hotels.facilities',
  'page.cart.hotels.check-in-out',
  'page.cart.hotels.from',
  'page.cart.hotels.until',
  'page.cart.hotels.select-room',
  'page.cart.hotels.sleeps',
  'page.cart.hotels.rooms-title',
  'page.cart.hotels.cart-title',
  'page.cart.hotels.another-title',
  'page.cart.hotels.another-description',
  'page.cart.hotels.add-another-button',
  'page.cart.hotels.edit-title',
  'page.cart.hotels.edit-description',
  'page.cart.hotels.in-basket',

  'page.checkout.title',
  'page.checkout.details.title',
  'page.checkout.details.description',
  'page.checkout.details.button',
  'page.checkout.details.back',
  'page.checkout.payment.title',
  'page.checkout.payment.description',
  'page.checkout.payment.button',
  'page.checkout.payment.checkbox.terms',
  'page.checkout.payment.checkbox.marketing',
  'page.checkout.gift-cards.title',
  'page.checkout.gift-cards.description',
  'page.checkout.gift-cards.code',
  'page.checkout.gift-cards.amount',
  'page.checkout.gift-cards.add-card',
  'page.checkout.gift-cards.apply-button',
  'page.checkout.gift-cards.error.amount',
  'page.checkout.gift-cards.error.invalid',
  'page.gift-card.purchase.unavailable',
  'page.checkout.gift-cards.unavailable',
  'page.checkout.gift-cards.applied',
  'page.checkout.gift-cards.applied-list',
  'page.checkout.gift-cards.invalid-list',
  'page.checkout.gift-cards.remaining-balance',
  'page.checkout.ticket-protection.title',
  'page.checkout.ticket-protection.add',
  'page.checkout.ticket-protection.partial',
  'page.checkout.ticket-protection.add-title',
  'page.checkout.ticket-protection.remove-title',
  'page.checkout.ticket-protection.whats-covered',
  'page.checkout.ticket-protection.summary',
  'page.checkout.ticket-protection.modal.title',
  'page.checkout.ticket-protection.modal.close',
  'page.checkout.ticket-protection.modal.decline',
  'page.checkout.ticket-protection.modal.unavailable',
  'page.account.ticket-protection.covered',
  'page.account.ticket-protection.terms',

  'page.order-confirmation.success.title',
  'page.order-confirmation.success.description',
  'page.order-confirmation.success.order-no',
  'page.order-confirmation.success.next.title',
  'page.order-confirmation.success.next.description',
  'page.order-confirmation.success.faqs.title',
  'page.order-confirmation.success.faqs.description',

  'page.order-confirmation.failed-payment.title',
  'page.order-confirmation.failed-payment.description',

  'page.order-confirmation.failed.title',
  'page.order-confirmation.failed.gift-card-hint',
  'page.order-confirmation.failed.reservation-hint',
  'page.order-confirmation.failed.reserve-again',

  'page.order-confirmation.processing.title',

  'page.email-verification.title',
  'page.email-verification.description',
  'page.email-verification.button',
  'page.email-verification.error.title',
  'page.email-verification.error.description',
  'page.email-verification.success.title',
  'page.email-verification.success.description',

  'page.reset-password.title',
  'page.reset-password.description',
  'page.reset-password.button',
  'page.reset-password.success.title',
  'page.reset-password.success.description',

  'page.search.seo-title',
  'page.search.subtitle',
  'page.search.no-results.description',

  'page.favourites.no-results.description',
  // football page
  'page.category-football.products',
  'page.category-football.teams',
  'page.category-football.guarantee.title',
  'page.category-football.guarantee.description',
  'page.category-football.guarantee2.title',
  'page.category-football.guarantee2.description',
  'page.category-football.guarantee.official',
  'page.category-football.guarantee.authorised-tickets',
  'page.category-football.e-tickets',
  'page.category-football.seat-together',
  'page.category-football.customer-support',


  'FirstClass',
  'StandardClass',

  'feedback.cart.added',
  'feedback.cart.hotel-added',
  'feedback.cart.hotel-removed',
  'feedback.email-change.toast',
  'feedback.email-change.title-success',
  'feedback.email-change.description-success',
  'feedback.email-change.title-error',
  'feedback.email-change.description-error',
  'feedback.cart.adding',
  'feedback.cart.removed',
  'feedback.gift-card.applied',
  'feedback.gift-card.removed',
  'feedback.copy.success',
  'feedback.coupon.added',
  'feedback.coupon.removed',
  'feedback.create-order.error',
  'feedback.checkout.security-check.required',
  'feedback.checkout.security-check.failed',
  'feedback.favourites.added',
  'feedback.favourites.login',
  'feedback.favourites.removed',
  'feedback.generic.error',
  'feedback.login.success',
  'feedback.newsletter.success',
  'feedback.payment.error',
  'feedback.phone.invalid',
  'page.checkout.payment.loading',
  'page.checkout.payment.load-error',
  'page.checkout.payment.retry',
  'feedback.checkout.prices-changed',
  'feedback.checkout.items-unavailable',
  'feedback.register.success',
  'feedback.reset-password.requested',
  'feedback.update-password.success',
  'feedback.update-profile.success',
  // ltd
  "ltd.noFee",
  "ltd.save",
  "ltd.descPrefix",
  "ltd.legend.all",
  "ltd.legend.noFees",
  "ltd.legend.offer",
  "ltd.basket.addSingle",
  "ltd.basket.addMultiple",
  "ltd.basket.addGrand",
  "ltd.basket.add",
  "ltd.preparing",

  'string.Card-Holder',

  // BOAT-1898
  'string.Sign-out-everywhere',
  'string.Sign-out-everywhere-description',
  'string.Sign-out-everywhere-action',
  'feedback.logout-everywhere.success',
  'feedback.session.expired',
  'feedback.session.expiring',

  // Price-drop feature (BOAT-1738)
  'string.Save-amount',
  'string.You-saved',

  // Deals page (BOAT-1862)
  'page.deals.title',
  'page.deals.description',
  'page.deals.results',
  'page.deals.sort-label',
  'page.deals.sort',
  'page.deals.sort-discount-asc',
  'page.deals.sort-date-asc',
  'page.deals.up-to-off',
  'page.deals.official',
  'page.deals.ticket-category',
  'page.deals.price-per-ticket',
  'page.deals.book',
  'page.deals.view-all',
  'page.deals.view-match',
  'page.deals.breadcrumb',
  'page.deals.empty.title',
  'page.deals.empty.description',
] as const

type Locale = (typeof locales)[number]
type TranslationKey = (typeof translationKeys)[number]

const stringSchema = z.string().trim().min(1)

const localizedStringSchema = z.object(
  locales.reduce(
    (acc, locale) => {
      acc[locale] = stringSchema
      return acc
    },
    {} as Record<Locale, z.ZodString>,
  ),
)

const schema = z
  .object(
    translationKeys.reduce(
      (acc, locale) => {
        acc[locale] = localizedStringSchema
        return acc
      },
      {} as Record<TranslationKey, typeof localizedStringSchema>,
    ),
  )
  .transform((data) => {
    const result = {} as Record<string, Record<string, string>>

    for (const [key, values] of Object.entries(data)) {
      for (const [locale, value] of Object.entries(values)) {
        if (!result[locale]) {
          result[locale] = {}
        }

        result[locale][key] = value
      }
    }

    return result as Record<Locale, Record<TranslationKey, string>>
  })

export const parseTranslations = (translations: string) => {
  const json = JSON.parse(translations)

  return schema.parse(json)
}
